export default "__VITE_ASSET__sbFMUi81__"